import { Card, Grid, pn, useElementBreakpoints, ValidationErrors } from "@compass/core";
import { DatePicker } from "components";
import { StudentReportNscDisplay } from "generated/openApi";
import produce from "immer";

export const NscDisplay = (props: {
  display: StudentReportNscDisplay;
  setDisplay: (filter: StudentReportNscDisplay) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();

  const dateField = () => {
    const propertyName = pn<StudentReportNscDisplay>("searchBeginDate");

    return (
      <DatePicker
        label="Search Begin Date"
        required
        errors={props.validationErrors[propertyName]}
        value={props.display.searchBeginDate}
        onChange={(value) => {
          props.setDisplay(
            produce(props.display, (draft) => {
              draft.searchBeginDate = value;
            })
          );
        }}
      />
    );
  };

  return (
    <Card header={"Display Items"}>
      <Grid ref={breakpointsRef} container>
        <Grid item xs={smallFieldBreakpoints}>
          {dateField()}
        </Grid>
      </Grid>
    </Card>
  );
};
